const userTypes = {
  SIGN_UP_START: "SIGN_UP_START",
  SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
  SIGN_UP_FAILURE: "SIGN_UP_FAILURE",
  SIGN_IN_START: "EMAIL_SIGN_IN_START",
  SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
  SIGN_IN_FAILURE: "SIGN_IN_FAILURE",
  SIGN_OUT_START: "SIGN_OUT_START",
  SIGN_OUT_SUCCESS: "SIGN_OUT_SUCCESS",
  SIGN_OUT_FAILURE: "SIGN_OUT_FAILURE",
  CHECK_USER_SESSION: "CHECK_USER_SESSION",
  APPROVE_USER_START: "APPROVE_USER_START",
  APPROVE_USER_SUCCESS: "APPROVE_USER_SUCCESS",
  APPROVE_USER_FAILURE: "APPROVE_USER_FAILURE",
  UPDATE_USER_START: "UPDATE_USER_START",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  UPDATE_USER_FAILURE: "UPDATE_USER_FAILURE",
  GET_USER_SUCCESS:"GET_USER_SUCCESS",
  GET_USER_FAILURE:"GET_USER_FAILURE",
  GET_ALL_USERS_START: "GET_ALL_USERS_START",
  GET_ALL_USERS_SUCCESS: "GET_ALL_USERS_SUCCESS",
  GET_ALL_USERS_FAILURE: "GET_ALL_USERS_FAILURE",
  SESSION_EXPIRED:"SESSION_EXPIRED",
  CHANGE_SETTINGS_START: "CHANGE_SETTINGS_START",
  CHANGE_SETTINGS_SUCCESS: "CHANGE_SETTINGS_SUCCESS",
  CHANGE_SETTINGS_FAILURE: "CHANGE_SETTINGS_FAILURE",
};

export default userTypes;
